/**
 * 车辆诊断 - 编辑联系方式弹窗
 */
import React, { useState, useEffect } from "react";
import { Modal, Form, message, Input } from "antd";
import { updateContactCarRequest } from '@/service/carManage';

/** 大陆手机号（与业管侧同字段校验一致）：1 开头第二位 3-9，共 11 位数字 */
const MOBILE_PHONE_PATTERN = /^1[3-9]\d{9}$/;

/** 输入时剔除文字等非数字字符，仅保留数字 */
const sanitizePhoneInput = (value: string) => (value || '').replace(/\D/g, '').slice(0, 11);

const phoneRules = [
  {
    validator: (_: any, value?: string) => {
      if (!value) {
        return Promise.resolve();
      }
      if (!MOBILE_PHONE_PATTERN.test(value)) {
        return Promise.reject(new Error('请输入正确的电话号码'));
      }
      return Promise.resolve();
    },
  },
];

interface AssignModalProps {
  data: any; // 工单信息
  type: string; // 操作类型(指派/重新指派)
  onClose: () => void; // 关闭弹窗的方法
  onOk?: () => void
}

const EditPhoneModal = (props: AssignModalProps) => {
  const { data, onClose, type, onOk } = props;
  const [loading, setLoading] = useState<boolean>(false); // 提交接口是否请求中
  const [form] = Form.useForm();
  const [submitNoRepetition, setSubmitNoRepetition] = useState(true); // 不能重复请求

  useEffect(() => {
    const oldValue = {
      carPrincipal: data.car_principal,
      carPrincipalPhone: sanitizePhoneInput(data.car_principal_phone || ''),
      carDriver: data.car_driver,
      carDriverPhone: sanitizePhoneInput(data.car_driver_phone || ''),
    }
    form.setFieldsValue(oldValue);
  }, []);

  // 指派工单
  const submit = async (values: any) => {
    if (submitNoRepetition) {
      setSubmitNoRepetition(false)
      try {
        const params:any = {};
        params.id = data.id
        params.carPrincipal = values.carPrincipal
        params.carPrincipalPhone = values.carPrincipalPhone
        params.carDriver = values.carDriver
        params.carDriverPhone = values.carDriverPhone
        const res = await updateContactCarRequest(params);
        setLoading(true);
        if (res.status == 200) {
          setSubmitNoRepetition(true)
        }
        setLoading(false);
        if (res.data?.code === 0) {
          message.success('修改成功');
          onClose();
          onOk && onOk()
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
  }

  return (
    <Modal
      title={'编辑联系方式'}
      visible
      centered
      onCancel={onClose}
      onOk={() => form.submit()}
      okButtonProps={{ loading }}
      maskClosable={false}
    >
      <Form
        form={form}
        autoComplete="off"
        layout="vertical"
        scrollToFirstError
        onFinish={submit}
      >
        <Form.Item label="负责人" style={{ marginBottom: 0 }}>
          <Form.Item
            name="carPrincipal"
            style={{ display: 'inline-block', width: 'calc(40% - 8px)' }}
          >
            <Input placeholder="请输入负责人姓名" />
          </Form.Item>
          <Form.Item
            name="carPrincipalPhone"
            style={{ display: 'inline-block', width: 'calc(60% - 8px)', margin: '0 8px' }}
            getValueFromEvent={(e) => sanitizePhoneInput(e?.target?.value)}
            rules={phoneRules}
            validateTrigger={['onChange', 'onBlur']}
          >
            <Input
              placeholder="请输入负责人联系方式"
              maxLength={11}
              inputMode="numeric"
            />
          </Form.Item>
        </Form.Item>
        <Form.Item label="司机" style={{ marginBottom: 0 }}>
          <Form.Item
            name="carDriver"
            style={{ display: 'inline-block', width: 'calc(40% - 8px)' }}
          >
            <Input placeholder="请输入司机姓名" />
          </Form.Item>
          <Form.Item
            name="carDriverPhone"
            style={{ display: 'inline-block', width: 'calc(60% - 8px)', margin: '0 8px' }}
            getValueFromEvent={(e) => sanitizePhoneInput(e?.target?.value)}
            rules={phoneRules}
            validateTrigger={['onChange', 'onBlur']}
          >
            <Input
              placeholder="请输入司机联系方式"
              maxLength={11}
              inputMode="numeric"
            />
          </Form.Item>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default EditPhoneModal;
